module.exports = __webpack_public_path__ + "static/media/logo-sundevs.75f7b63a.png";